
import React from 'react';
import * as icons from "./fileTypesIcons.js";

function Icon_Selector(props) {

    const { icon, width, height } = props;
    const iconToShow = icons.iconMapping(icon);

    return (
        <img width={width || "28"} height={height || "28"} src={iconToShow} alt={icon} />
    );
}


export default Icon_Selector